import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSale, setCurrentSale] = useState({
    name: '',
    city: ''
  });
  const names = ['Joaquín', 'Mateo', 'Bautista', 'Nicolás', 'Tomás', 'Facundo', 'Santiago', 'Ignacio', 'Lucas', 'Agustín'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Tucumán', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentSale({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 10000);
    // Subsequent popups every 20-35 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        triggerPopup();
      }
    }, Math.floor(Math.random() * 15000) + 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-194">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-zinc-900 border border-zinc-700 rounded-lg shadow-2xl p-4 flex items-center gap-4 max-w-sm" data-id="element-195">
          <div className="bg-lime-500/20 p-2 rounded-full shrink-0" data-id="element-196">
            <CheckCircle2 className="w-6 h-6 text-lime-500" data-id="element-197" />
          </div>
          <div data-id="element-198">
            <p className="text-sm text-zinc-300" data-id="element-199">
              <span className="font-bold text-white" data-id="element-200">{currentSale.name}</span>{' '}
              de {currentSale.city}
            </p>
            <p className="text-xs text-lime-400 font-medium" data-id="element-201">
              Acaba de comprar el sistema
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};